import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module'
import { AdvisorRoutingModule } from './advisor-routing.module';
import { AdvisorComponent } from './advisor.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ProfileComponent } from './components/profile/profile.component';
import { AdvisorNavComponent } from './components/advisor-nav/advisor-nav.component';
import { RmdTrackerAdvisorComponent } from './components/rmd-tracker-advisor/rmd-tracker-advisor.component';


@NgModule({
  declarations: [
    AdvisorComponent,
    DashboardComponent,
    ProfileComponent,
    AdvisorNavComponent,
    RmdTrackerAdvisorComponent
  ],
  imports: [
    CommonModule,
    AdvisorRoutingModule,
    SharedModule
  ]
})
export class AdvisorModule { }
